import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { getMaterialTypesFromProducts } from '../../../helpers/material';
import { getMaterialTypeNightFromProducts } from '../../../helpers/materialTypeNight';
import { mapOptionsOrder } from '../../../helpers/optionsSort';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Caption } from '../../Common/Caption';
import { Heading } from '../../Common/Heading';
import { Selector, SelectorImageItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  materialTypeNight: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (materialTypeNight, send) => () =>
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      materialTypeNight,
    },
  });

export const MaterialTypeNight = () => {
  const [state, send] = useService(productBuilderMachine);
  const {
    products,
    custom: { materialTypeNight },
  } = state.context;

  const materialTypes = getMaterialTypesFromProducts(products);
  const productType = getBaseProductType(state.context);

  if (
    isCurrentState('materialTypeNight', state) &&
    materialTypes.length === 0
  ) {
    throwError(state);
  }

  // New requirement, only the Night (back fabric) is allowed to be Blockout
  const materialNightTypesExcludingSunscreen = materialTypes.filter(
    material => material !== 'Sunscreen',
  );

  const materialTypesOrder = ['Blockout', 'Light Filter', 'Sunscreen', 'Sheer'];
  let sortedMaterialTypes = mapOptionsOrder(
    materialNightTypesExcludingSunscreen,
    materialTypesOrder,
  );

  return (
    <SectionContent>
      <Heading>Material type - night</Heading>
      <Selector isSlider={true}>
        {sortedMaterialTypes.map(materialType => {
          const isSelected = materialType === materialTypeNight;
          const { showIcon, Icon, description } = getProductStateConfig(
            productType,
            'materialTypeNight',
            materialType,
          );
          return (
            <SelectorImageItem
              isSelected={isSelected}
              onClick={onClick(materialType, send)}
              key={materialType}
              showIcon={showIcon}
              Icon={Icon}
              title={materialType}
              description={description}
            />
          );
        })}
      </Selector>
    </SectionContent>
  );
};
